import { string, number } from 'prop-types';
import styled from 'styled-components/macro';

import EntityItemLoader from '../EntityItemLoader/EntityItemLoader';

const ListItem = styled('li')`
  padding: ${({ theme }) => theme.spacing.small};
  border-bottom: 1px solid ${({ theme }) => theme.LightGrey};
  margin: 0 -${({ theme }) => theme.spacing.small};

  @media screen and (min-width: 43em) {
    margin: 0;
    padding: ${({ theme }) => theme.spacing.small} 0;
  }
`;

const SearchResultsListItem = ({ entityType, className }) => {
  return (
    <ListItem className={className}>
      <EntityItemLoader entityType={entityType} />
    </ListItem>
  );
};

SearchResultsListItem.propTypes = {
  /** Optional className for additional styling */
  className: string,
  /** The entityType that we are displaying */
  entityType: string,
};

const SearchResultsLoader = (props) => {
  return (
    <ul>
      {Array(props.itemCount)
        .fill()
        .map((value, index) => (
          <SearchResultsListItem
            {...props}
            key={`search-results-list-item-${index}`}
          />
        ))}
    </ul>
  );
};

SearchResultsLoader.defaultProps = {
  itemCount: 5,
};

SearchResultsLoader.propTypes = {
  /** The number of rows to show */
  itemCount: number,
};

export default SearchResultsLoader;
